import React from 'react';

function LocalOfferIcon({
  className,
  ...props
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.342 2.14999L17.842 9.64999C18.142 9.94999 18.3337 10.375 18.3337 10.8333C18.3337 11.2917 18.1503 11.7083 17.842 12.0083L12.0087 17.8417C11.7087 18.15 11.292 18.3333 10.8337 18.3333C10.3753 18.3333 9.95866 18.15 9.65866 17.85L2.15866 10.35C1.85033 10.0417 1.66699 9.62499 1.66699 9.16666V3.33332C1.66699 2.41666 2.41699 1.66666 3.33366 1.66666H9.16699C9.62533 1.66666 10.042 1.84999 10.342 2.14999ZM3.33366 4.58332C3.33366 5.27499 3.89199 5.83332 4.58366 5.83332C5.27533 5.83332 5.83366 5.27499 5.83366 4.58332C5.83366 3.89166 5.27533 3.33332 4.58366 3.33332C3.89199 3.33332 3.33366 3.89166 3.33366 4.58332Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default LocalOfferIcon;
